import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import ProductCategoryPage from './pages/ProductCategoryPage'
import BlogPage from './pages/BlogPage'
import BlogDetailPage from './pages/BlogDetailPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import ServicesPage from './pages/ServicesPage'

function App() {
  return (
    <Router>
      <div data-component-path="client/src/App.jsx" data-component-line="1:1" data-component-id="client/src/App.jsx:1:1" className="min-h-screen flex flex-col bg-gray-50">
        <Navbar />
        <main data-component-path="client/src/App.jsx" data-component-line="2:2" data-component-id="client/src/App.jsx:2:2" className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/urunler/:category" element={<ProductCategoryPage />} />
            <Route path="/hizmetler" element={<ServicesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/gizlilik-politikasi" element={<PrivacyPolicyPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App